// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@tps/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 0,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 18px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    size: 14,
    color: "text",
    css: css`
        &&& > * {
            font-size: 14px;
            line-height: 22px;
            color: ${color("text.main")};
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = { 
    variant: "secondary",
    css: css`
        min-height: 31px;
    `,
};

